import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import it from "./locales/it.json";
import en from "./locales/en.json";

const STORAGE_KEY = "dvrprosuite_lang";
const detected = typeof window !== "undefined" ? window.localStorage.getItem(STORAGE_KEY) : null;

i18n.use(initReactI18next).init({
  resources: { it: { translation: it }, en: { translation: en } },
  lng: detected || "it",
  fallbackLng: "it",
  interpolation: { escapeValue: false },
});

export function setAppLanguage(lang) {
  i18n.changeLanguage(lang);
  if (typeof window !== "undefined") window.localStorage.setItem(STORAGE_KEY, lang);
}

export default i18n;
